import { Container, Grid, Typography, Box, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import BraincubeBanner from "../../asset/images/braincube/banner/transforming-industrial-productivity.webp";
import Forging from "../../asset/images/braincube/forging.webp";
import Maple from "../../asset/images/braincube/maple.webp";
import Readiness from "../../asset/images/braincube/ai-readiness.webp";


import processing1 from "../../asset/images/oracle/processing/processing1.png";
import processing2 from "../../asset/images/oracle/processing/processing2.png";
import processing3 from "../../asset/images/braincube/applications/empower.webp";

import app1 from "../../asset/images/braincube/applications/purpose.webp";
import app2 from "../../asset/images/braincube/applications/actionable.webp";
import app3 from "../../asset/images/braincube/applications/seamless.webp";
import app4 from "../../asset/images/braincube/applications/quick.webp";
import app5 from "../../asset/images/braincube/applications/collaborative.webp";

import BraincubeContactUs from '../../Component/forms/BraincubeContactUs';


export default function Braincube() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    // Scroll to form started
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const stickyItemsHeight = 30;
            const offset = element.getBoundingClientRect().top - stickyItemsHeight;


            setTimeout(() => {
                window.scrollBy({ top: offset, behavior: 'smooth' });
            }, 50);
        }
    };

    useEffect(() => {
        const { hash } = window.location;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const offset = 50;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition - offset;
                window.scrollBy({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    }, []);
    // Scroll to form ended

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title> AI-Driven Industrial Transformation | Braincube Partnership </title>
                <meta name="description" content="Explore the powerful partnership between Decimal Point Analytics and Braincube driving AI-powered solutions to enhance manufacturing productivity & efficiency." />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/braincube" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box id="new_landing_carousel" className='ibmbanner'>
                <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + BraincubeBanner + ")" }} pb={2}>
                    <Container maxWidth="lg">
                        <Grid container spacing={1} alignItems="center" justifyContent='center'>
                            <Grid item lg={9} md={12} sm={11} xs={10}>
                                <Box className="text_animated mb0">
                                    <Typography variant="h2" className="blue fw6 mb0" gutterBottom>
                                        Transforming Industrial Productivity <span className='lower'>with</span> AI
                                    </Typography>

                                    <Box>
                                        <Typography variant="h2" className="black3" gutterBottom>
                                            <span className='fw4'>Decimal Point Analytics <span className='lower'>partners with</span> <strong><span className='bcube_text'>BRAINCUBE</span></strong> <span className='lower'>to drive measurable productivity and eliminate hidden inefficiencies in manufacturing.</span></span>
                                        </Typography>
                                    </Box>

                                    <Box mt={2}>
                                        <Link to="/braincube#briancubecontactus" onClick={() => scrollToElement('briancubecontactus')}>
                                            <Button variant="contained" className='dpabtn_sm1'>
                                                Get In Touch
                                            </Button>
                                        </Link>
                                    </Box>

                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Box>
            </Box>

            <Box className='section2' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container direction="row"
                        justifyContent="center"
                        alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">
                                <Typography variant='h2' className='black'>
                                    Decimal Point Analytics + <strong><span className='bcube_text'>BRAINCUBE</span></strong>: Transforming Manufacturing Intelligence
                                </Typography>
                                <Typography variant='h6' className='black al_center mb0' gutterBottom>
                                    At Decimal Point Analytics, we are proud to partner with <strong>Braincube,</strong> a global leader in industrial AI and productivity management.

                                    This collaboration brings cutting-edge digital transformation solutions to manufacturers seeking to achieve data-driven decision-making, eliminate production inefficiencies, and scale performance across plants.Our partnership empowers manufacturers with actionable insights, driven by AI, to move beyond incremental improvements and achieve Total Productivity.
                                </Typography> 
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section mob_card sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='center'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center'>
                                    <Typography variant='h2' className='black'>
                                        Transform Your Operations — At Every Level
                                    </Typography>
                                </Box>

                            </Grid>
                        </Grid>


                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing1} className='allic' alt='Autonomy and Self-Management' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom>Uncover Hidden Potential</Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    AI identifies inefficiencies across operations
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing3} className='allic' alt='Performance Acceleration' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom>Empower Every Level</Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    From engineers to leadership—enable real-time, data-driven decisions
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing2} className='allic' alt='Security Fortification' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom>Scale with Confidence</Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    Validate and replicate gains across machines, lines, and plants
                                </Typography>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className="section" component="section">
                <Container maxWidth="lg" className="bdr">
                    <Grid container spacing={2} alignItems="center" justifyContent='center'>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">
                                <Typography variant="h2" className="black">
                                    Real-World Success Stories
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className='reportinfo'>
                                <Box className="reportm_bg">
                                    <Box
                                        className="reportimg_bg"
                                        style={{
                                            backgroundImage: 'url(' + Forging + ')',
                                        }}
                                    >
                                        <Button variant="contained" className='ora_title_btn'>
                                            Case Study
                                        </Button>
                                    </Box>

                                    <Box my={2}>
                                        <Typography className="reporttitle two" title="Forging the Future: How Aubert & Duval is Redefining Manufacturing Productivity">
                                            Forging the Future: How Aubert & Duval is Redefining Manufacturing Productivity
                                        </Typography>
                                    </Box>
                                    <Box className="line"></Box>
                                    <Box mt={2}>
                                        <a href='https://braincube.com/customer-stories/aubert-duval-redefining-manufacturing-productivity/' target='_blank' rel="noopener noreferrer">
                                            <Button variant="contained" className='dpabtn_sm1' endIcon={<NavigateNextIcon />}>
                                                Read More
                                            </Button>
                                        </a>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className='reportinfo'>
                                <Box className="reportm_bg">
                                    <Box
                                        className="reportimg_bg"
                                        style={{
                                            backgroundImage: 'url(' + Maple + ')',
                                        }}
                                    >
                                        <Button variant="contained" className='ora_title_btn'>
                                            Case Study
                                        </Button>
                                    </Box>

                                    <Box my={2}>
                                        <Typography className="reporttitle two" title="Maple Leaf Foods: Towards Zero Waste And Total Productivity">
                                            Maple Leaf Foods: Towards Zero Waste And Total Productivity
                                        </Typography>
                                    </Box>
                                    <Box className="line"></Box>
                                    <Box mt={2}>
                                        <a href='https://braincube.com/customer-stories/maple-leaf-foods-zero-waste-total-productivity/' target='_blank' rel="noopener noreferrer">
                                            <Button variant="contained" className='dpabtn_sm1' endIcon={<NavigateNextIcon />}>
                                                Read More
                                            </Button>
                                        </a>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className='reportinfo'>
                                <Box className="reportm_bg">
                                    <Box
                                        className="reportimg_bg"
                                        style={{
                                            backgroundImage: 'url(' + Readiness + ')',
                                        }}
                                    >
                                        <Button variant="contained" className='ora_title_btn'>
                                            Case Study
                                        </Button>
                                    </Box>

                                    <Box my={2}>
                                        <Typography className="reporttitle two" title="AI-Readiness Assessment for Manufacturers: Is Your Data Ready?">
                                            AI-Readiness Assessment for Manufacturers: Is Your Data Ready?
                                        </Typography>
                                    </Box>
                                    <Box className="line"></Box>
                                    <Box mt={2}>
                                        <a href='https://braincube.com/resources/ai-readiness-assessment-mamanufacturers/' target='_blank' rel="noopener noreferrer">
                                            <Button variant="contained" className='dpabtn_sm1' endIcon={<NavigateNextIcon />}>
                                                Read More
                                            </Button>
                                        </a>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box >

            <Box id='sba_solutions' className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='left'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center'>
                                    <Typography variant='h2' className='black'>
                                        The Right Partnership <span className='lower'>for</span> Industrial Transformation
                                    </Typography>

                                    <Typography variant='h6' className='black al_center mb0'>
                                        Our partnership brings together deep industrial context and AI-driven clarity to solve real manufacturing challenges.
                                    </Typography>

                                    <Typography variant='h6' className='black al_center'>
                                        It’s not about more data — it’s about the right insights, delivered in a way your teams can act on.
                                    </Typography>
                                </Box>

                            </Grid>
                        </Grid>


                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={app1} className='allic' alt='Purpose-Built for Manufacturers' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Purpose-Built for Manufacturers </Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        The tools and frameworks are tailored for the complexity of industrial environments—not generic AI.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={app2} className='allic' alt='Actionable Insights, Not Just Data' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Actionable Insights, Not Just Data</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        We focus on delivering insights teams can act on, not just dashboards or reports.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={app4} className='allic' alt='Quick, Measurable Outcomes' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Quick, Measurable Outcomes</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Manufacturers begin seeing tangible improvements in efficiency and decision-making within a short span.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={app3} className='allic' alt='Seamless Team Enablement' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Seamless Team Enablement</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        From line operators to plant heads, the solution is designed to be accessible and practical.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={app5} className='allic' alt='Collaborative Implementation' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Collaborative Implementation</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        We work alongside your teams—not just as technology providers, but as partners in problem-solving.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>

            <Box id='briancubecontactus'>
                <BraincubeContactUs />
            </Box>

        </>
    );
}
